// Canonical host + framing guards for the application shell (ADR-004 decision #12, ADR-016 framing policy).
// Pure functions; applied once in index.js before the first render. Production builds only.

// The application is served from the same origin as its API. In production that origin is fixed by build configuration
// (REACT_APP_BACKEND_URL = https://app.bizii.ca); any other page origin (e.g. the platform host) is redirected there.
export function canonicalOrigin(apiBaseUrl) {
  try {
    const url = new URL(apiBaseUrl);
    return url.protocol === "https:" ? url.origin : null;
  } catch {
    return null;
  }
}

// Returns the absolute canonical URL to navigate to, or null when already canonical / not applicable.
// Only the current path, query and hash are carried over; the authority is never taken from the current location.
export function canonicalRedirect(location, apiBaseUrl, nodeEnv) {
  if (nodeEnv !== "production") return null;
  const origin = canonicalOrigin(apiBaseUrl);
  if (!origin || location.origin === origin) return null;
  const path = (location.pathname || "/").replace(/^\/+/, "/");
  return origin + path + (location.search || "") + (location.hash || "");
}

// True when the document is embedded in any frame. No embed route exists yet (0.4D.1): every framed render is refused.
export function isFramed(win) {
  try {
    return win.top !== win.self;
  } catch {
    return true; // cross-origin parent blocks the comparison → treat as framed (fail closed)
  }
}
